import { Box, IconButton, Tooltip, Typography } from '@mui/material'

interface SidebarButtonProps {
    icon: string
    label: string
    selected?: boolean
    disabled?: boolean
    onClick: () => void
}

// invert() on a pure-black SVG stroke:
//   invert(0%)   → black  (#000)
//   invert(29%)  → #494949 (default state)
//   invert(81%)  → #cecece (disabled state)
//   invert(100%) → white   (active state)
const iconFilter = (selected: boolean, disabled: boolean) => {
    if (disabled) return 'invert(81%)'
    if (selected) return 'invert(100%)'
    return 'invert(29%)'
}

const SidebarButton = ({ icon, label, selected = false, disabled = false, onClick }: SidebarButtonProps) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 48 }}>
        <Tooltip title={label} placement="right">
            <span>
                <IconButton
                    onClick={onClick}
                    disabled={disabled}
                    sx={{
                        backgroundColor: disabled ? '#f7f7f7' : selected ? '#2d2d2d' : '#fff',
                        borderRadius: '100px',
                        width: 46,
                        height: 46,
                        '&:hover': {
                            backgroundColor: disabled ? '#f7f7f7' : selected ? '#2d2d2d' : '#f0f0f0',
                            transform: disabled ? 'none' : 'scale(1.05)',
                        },
                        '&.Mui-disabled': {
                            backgroundColor: '#f7f7f7',
                        },
                        transition: 'all 0.2s ease-in-out',
                    }}
                >
                    <Box
                        component="img"
                        src={icon}
                        alt=""
                        sx={{
                            width: 22,
                            height: 22,
                            filter: iconFilter(selected, disabled),
                            transition: 'filter 0.2s ease-in-out',
                            pointerEvents: 'none',
                            userSelect: 'none',
                        }}
                    />
                </IconButton>
            </span>
        </Tooltip>
        <Typography
            sx={{
                fontFamily: 'Urbanist, sans-serif',
                fontWeight: 400,
                fontSize: 12,
                color: disabled ? '#cecece' : '#494949',
                textAlign: 'center',
                mt: 0.25,
            }}
        >
            {label}
        </Typography>
    </div>
)

export default SidebarButton
